import { Modal } from "react-bootstrap";
import LabelViewer from "../LabelViewer";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getLabelsForMultipleDeliveries } from "../../services/deliveryService";
import { isClient } from "../../services/accountService";
import handleApiError from "../../helpers/handleApiError";
import PDFObject from "pdfobject";

const viewStates = {
  success: "success",
  loading: "loading",
  nodata: "nodata",
  error: "error",
};

export default LabelViewer;

export const LabelViewerModal = ({ show, onHide, deliveryId }) => {
  const [viewState, setViewState] = useState(viewStates.loading);
  const history = useHistory();

  useEffect(() => {
    (async () => {
      if (!deliveryId) {
        return;
      }
      setViewState(viewStates.loading);

      try {
        const { data } = await getLabelsForMultipleDeliveries(
          "" + deliveryId,
          false,
          isClient()
        );
        // await sleep(31000);
        setViewState(viewStates.success);
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
          PDFObject.embed(reader.result, "#pdf-container");
        };
      } catch (ex) {
        setViewState(viewStates.error);
        handleApiError(ex, history);
      }
    })();
  }, [deliveryId]);

  return (
    <Modal show={show} onHide={onHide} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Viewing Labels</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ height: "75dvh" }}>
          <div
            id="pdf-container"
            style={{
              height: viewState === viewStates.success ? "100%" : "0",
              backgroundColor: "rgb(82,86,89)",
            }}
          ></div>
          {viewState === viewStates.loading && (
            <div
              style={{
                height: "100%",
                backgroundColor: "rgb(82,86,89)",
                color: "white",
                display: "grid",
                placeContent: "center",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <div className="spinner-border p-3 m-2" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <br />
                Retrieving Labels
              </div>
            </div>
          )}
          {viewState === viewStates.error && (
            <div
              style={{
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                display: "grid",
                placeContent: "center",
              }}
            >
              There was an error retrieving label for this order. Please make
              sure the order has not been voided and you are connected to the
              internet.
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary w-100" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};
